import { createRouter, createWebHistory } from 'vue-router'
import Home from './pages/Home.vue'
import Signin from './pages/Signin.vue'
import AdminDashboard from './pages/admin/AdminDashboard.vue'
import AdminProfile from './pages/admin/AdminProfile.vue'
import AdminResume from './pages/admin/AdminResume.vue'
import AdminMessages from './pages/admin/AdminMessages.vue'
import AdminAnalytics from './pages/admin/AdminAnalytics.vue'
import AdminPortfolio from './pages/AdminPorfolio.vue'
import AddPortfolio from './pages/Portfolio/Create.vue'
import NotFound from './pages/NotFound.vue'
import { SCROLL_SPY_OFFSET } from './utils/scrollSpy'
import { waitForAuth, useAuth } from './composables/useAuth'
import { liveProducts } from './data/profile'

const routes = [
  { path: '/', name: 'home', component: Home, meta: { layout: 'default' } },
  { path: '/about', redirect: { path: '/', hash: '#about' } },
  { path: '/work', redirect: { path: '/', hash: '#work' } },
  { path: '/resume', redirect: { path: '/', hash: '#resume' } },
  { path: '/portfolio', redirect: '/' },
  { path: '/contact', redirect: { path: '/', hash: '#contact' } },
  ...liveProducts.map((product) => ({
    path: `/${product.id}`,
    name: `live-${product.id}`,
    beforeEnter() {
      window.location.href = product.liveUrl
      return false
    },
  })),
  { path: '/signin', name: 'signin', component: Signin, meta: { layout: 'auth' } },
  { path: '/admin', name: 'admin-dashboard', component: AdminDashboard, meta: { layout: 'default', requiresAuth: true } },
  { path: '/admin/profile', name: 'admin-profile', component: AdminProfile, meta: { layout: 'default', requiresAuth: true } },
  { path: '/admin/resume', name: 'admin-resume', component: AdminResume, meta: { layout: 'default', requiresAuth: true } },
  { path: '/admin/messages', name: 'admin-messages', component: AdminMessages, meta: { layout: 'default', requiresAuth: true } },
  { path: '/admin/analytics', name: 'admin-analytics', component: AdminAnalytics, meta: { layout: 'default', requiresAuth: true } },
  { path: '/admin/portfolio', name: 'admin-portfolio', component: AdminPortfolio, meta: { layout: 'default', requiresAuth: true } },
  { path: '/admin/portfolio/create', name: 'admin-portfolio-create', component: AddPortfolio, meta: { layout: 'default', requiresAuth: true } },
  { path: '/admin/setup', redirect: '/admin' },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound, meta: { layout: 'default' } },
]

const SCROLL_OFFSET = SCROLL_SPY_OFFSET

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition

    if (to.hash) {
      return new Promise((resolve) => {
        const scrollToHash = () => {
          const el = document.querySelector(to.hash)
          if (el) {
            resolve({ el: to.hash, top: SCROLL_OFFSET, behavior: 'smooth' })
          } else {
            setTimeout(scrollToHash, 50)
          }
        }
        setTimeout(scrollToHash, 50)
      })
    }

    return { top: 0, behavior: 'smooth' }
  },
})

router.beforeEach(async (to) => {
  if (to.meta.requiresAuth) {
    await waitForAuth()
    const { isAuthenticated } = useAuth()
    if (!isAuthenticated.value) {
      return { path: '/signin', query: { redirect: to.fullPath } }
    }
  }

  if (to.path === '/signin') {
    await waitForAuth()
    const { isAuthenticated } = useAuth()
    if (isAuthenticated.value) {
      return typeof to.query.redirect === 'string' ? to.query.redirect : { path: '/admin' }
    }
  }
})

export default router
